export enum TodoTypeEnums {
    SELF = 'SELF',
    CLEAR_TODO = 'Clear TO-DO',
    ADDITIONAL_CONSENT_REQUIRED_TODO = 'additionConsentRequiredTodo',
    IDENTIFICATION_CARD_TODO = 'identificationCardTodo',
  }